export default __webpack_public_path__ + "static/media/peertoboss.d41a3f76.png";